import '@fortawesome/fontawesome-pro/js/light'
import '@fortawesome/fontawesome-pro/js/regular'
import '@fortawesome/fontawesome-pro/js/solid'
import '@fortawesome/fontawesome-pro/js/brands'
import '@fortawesome/fontawesome-pro/js/fontawesome'

import PropTypes from 'prop-types'
import { GlobalStyle, theme } from '@redriverpress/system'
import { ThemeProvider } from 'styled-components'

export default function ElliiThemeProvider({ children }) {
  return (
    <ThemeProvider theme={theme}>
      <GlobalStyle />
      {children}
    </ThemeProvider>
  )
}

ElliiThemeProvider.propTypes = {
  children: PropTypes.node.isRequired,
}
